<script>
import swal from 'sweetalert2'
import { mapActions } from 'vuex'

export default {
  name: 'dialog-upload-photos-event',
  props: {
    eventId: {
      required: true,
      type: String
    },
    show: {
      required: true,
      type: Boolean
    },
    files: {}
  },

  watch: {
    show () {
      if (this.show === true) {
        this.showDialog()
      }
    }
  },

  methods: {
    ...mapActions('events', ['getInsertDocEvent', 'uploadPhotosEvent']),
    showDialog () {
      this.getInsertDocEvent({ _id: this.eventId })
        .then(response => {
          swal({
            titleText: 'Confirmar envio das fotos?',
            text: `Confirmar o envio de ${this.files.length} fotos?`,
            confirmButtonText: 'Enviar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCloseButton: true,
            showConfirmButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              for (let file of this.files) {
                await this.uploadPhotosEvent({
                  id: response,
                  mimeType: 'image/jpg',
                  name: 'imagem_evento_' + (new Date()).getTime() + '.jpg',
                  file: file.blob
                })
              }
            }
          })
            .then(() => this.$emit('upload-photos', true))
            .catch(err => console.log(err))
        })
    }
  },

  render () {
    return null
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/UploadPhotos/DialogUploadPhotosEvent.vue